import develop1 from '../../assets/img/company/whatwedo/develop1.png';
import develop2 from '../../assets/img/company/whatwedo/develop2.png';
import produce1 from '../../assets/img/company/whatwedo/produce1.png';
import produce2 from '../../assets/img/company/whatwedo/produce2.png';
import install1 from '../../assets/img/company/whatwedo/install1.png';
import install2 from '../../assets/img/company/whatwedo/install2.png';
import service1 from '../../assets/img/company/whatwedo/service1.png';
import service2 from '../../assets/img/company/whatwedo/service2.png';

import develop from '../../assets/img/company/patents/certificate/develop.png';
import venture from '../../assets/img/company/patents/certificate/venture.png';
import iso9001 from '../../assets/img/company/patents/certificate/iso9001.png';
import iso14001 from '../../assets/img/company/patents/certificate/iso14001.png'
import iso45001 from '../../assets/img/company/patents/certificate/iso45001.png'
import family from '../../assets/img/company/patents/certificate/family.png'
import sps from '../../assets/img/company/patents/certificate/sps.png'
import mainbiz from '../../assets/img/company/patents/certificate/mainbiz.png'
import innobiz from '../../assets/img/company/patents/certificate/innobiz.png'


import designPatent01 from '../../assets/img/company/patents/patent/designPatent_1.png';
import designPatent02 from '../../assets/img/company/patents/patent/designPatent_2.png';
import designPatent03 from '../../assets/img/company/patents/patent/designPatent_3.png';


export const bussinessDatas = [
  {
    title: 'develop',
    ko_title: '기술 개발 및 연구',
    columns: [
      {
        img: develop1,
        subTitle: '전문가들의 기술력',
        desc:
          '중문 기술 개발에 관한 국내 최고라 자랑할만한 전문가들이 더 나은 기술을 위해 연구하고 개발하고 있습니다.',
      },
      {
        img: develop2,
        subTitle: '트랜드를 선도하는 기업',
        desc:
          '점점 더 빨라지는 인테리어 트랜드에 한발 앞서 세련되고 모던한 디지인을 추구하는 도어업계의 선도 기업입니다.',
      },
    ],
  },
  {
    title: 'product',
    ko_title: '제품 생산',
    columns: [
      {
        img: produce1,
        subTitle: '완벽한 제품으로 인정받는 기업',
        desc:
          '한치의 오차도 허락하지 않는 자체 생산력의 빈틈없는 시스템으로 완벽한 제품으로 인정받는 기업입니다',
      },
      {
        img: produce2,
        subTitle: '제품으로 신뢰받는 기업',
        desc:
          '부품과 디자인 모두 책임있는 제품으로 생산하여 고객이 신뢰하는 기업으로 성장해 나가겠습니다.',
      },
    ],
  },
  {
    title: 'install',
    ko_title: '제품 시공',
    columns: [
      {
        img: install1,
        subTitle: '맞춤시공까지 책임지는 기업',
        desc:
          '전문 시공팀에서 맞춤 제작된 제품을 마지막까지 깔끔한 시공으로 책임지는 기업입니다.',
      },
      {
        img: install2,
        subTitle: '고객이 만족하는 시공',
        desc:
          '디자인까지 생각하여 고객이 원하는 공간에 사용하기 편안한 디자인으로 시공을 책임지고 있습니다.',
      },
    ],
  },
  {
    title: 'service',
    ko_title: '고객감동 서비스',
    columns: [
      {
        img: service1,
        subTitle: '신뢰받는 기업',
        desc:
          '고객을 위한 맞춤 서비스는 설계에서부터 생산 시공까지 책임지며 고객의 만족을 신뢰로 받기위해 끊임없이 노력하는 기업입니다.',
      },
      {
        img: service2,
        subTitle: '고객의 행복을 추구하는 기업',
        desc:
          '미소테크는 고객이 행복할 때 미소짓고 고객이 만족할 때 더욱 힘이 나는 고객의 행복을 추구하는 기업입니다.',
      },
    ],
  },
];

export const patentData = [
  {
    title: '인증서',
    patents: [
      { name: '벤처기업확인서', img: venture },
      { name: '연구전담부서', img: develop },
      { name: '가족친화인증서', img: family },
      { name: '단체표준인증서', img: sps },
      { name: '이노비즈', img: innobiz },
      { name: '메인비즈', img: mainbiz},
      { name: 'ISO9001', img: iso9001},
      { name: 'ISO14001', img: iso14001},
      { name: 'ISO45001', img: iso45001 },
    ],
  },
  {
    title: '특허',
    patents: [
      { name: '디자인특허 제 10-2234035 호', img: designPatent01 },
      { name: '디자인특허 제 10-2344665 호', img: designPatent02 },
      { name: '디자인특허 제 10-2516719 호', img: designPatent03 },
    ],
  },
 
];

export const mapData = [
  {
    title: '주소',
    icon: 'fas fa-industry',
    content: '경기도 남양주시 화도읍 수레로 961번길 25-30 주식회사 미소테크',
  },
  { title: '전화번호', icon: 'fas fa-phone-alt', content: '031-594-1042' },
  { title: '팩스번호', icon: 'fas fa-fax', content: '031-594-1040' },
  { title: '이메일', icon: 'fas fa-envelope', content: 'misotech7@naver.com' },
  { title: '홈페이지', icon: 'fas fa-home', content: 'www.misotech7.com' },
];

export const introData = [
  { title: '회사명', content: '주식회사 미소테크', icon: 'fas fa-globe' },
  { title: '설립일', content: '2017.09.16', icon: 'far fa-list-alt' },
  { title: '대표이사', content: '이성태', icon: 'fas fa-people-arrows' },
  { title: '직원수', content: '16 명', icon: 'fas fa-users' },
  { title: '자본금', content: '₩ 100,000,000', icon: 'fas fa-dollar-sign' },
];
